import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "ui/components/dialog";

import { Button } from "ui/components/button";
import ButtonWithLoading from "components/button-with-loading";
import { useDeleteTimesheetEntry } from "components/timesheet/delete/mutation";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function DeleteTimesheetEntry({ entryId, date }) {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const navigate = useNavigate();

  const deleteEntryMutation = useDeleteTimesheetEntry({
    entryId,
    date,
    onSuccess: () => {
      setShowDeleteDialog(false);
      navigate(-1);
    },
  });

  const handleDelete = () => {
    deleteEntryMutation.mutate();
  };

  return (
    <>
      <ButtonWithLoading
        variant="destructive"
        onClick={() => setShowDeleteDialog(true)}
        disabled={deleteEntryMutation.isPending}
        // isLoading={deleteEntryMutation.isPending}
      >
        Delete
      </ButtonWithLoading>

      <Dialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Are you sure?</DialogTitle>
            <DialogDescription>
              Are you sure you want to delete this log? This action cannot be
              undone.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="gap-2">
            <Button
              variant="outline"
              onClick={() => setShowDeleteDialog(false)}
              disabled={deleteEntryMutation.isPending}
            >
              Cancel
            </Button>
            <ButtonWithLoading
              variant="destructive"
              onClick={handleDelete}
              disabled={deleteEntryMutation.isPending}
              isLoading={deleteEntryMutation.isPending}
            >
              {deleteEntryMutation.isPending ? "Deleting..." : "Delete"}
            </ButtonWithLoading>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
